import React, {Component} from 'react';
import {FadeIn} from 'animate-components';

const apps_operating_systems = [
   {
      icon: 'icon-ubuntu',
      title: 'Ubuntu'
   },{
      icon: 'icon-debian',
      title: 'Debian'
   },{
      icon: 'icon-apache',
      title: 'Apache'
   },{
      icon: 'icon-nginx',
      title: 'Nginx'
   },{
      icon: 'icon-osx',
      title: 'MacOS'
   },{
      icon: 'icon-git',
      title: 'Git'
   },{
      icon: 'icon-npm',
      title: 'NPM'
   }
]

const backend = [
   {
      icon: 'icon-nodejs',
      title: 'Node.js'
   },{
      icon: 'icon-python',
      title: 'Python'
   },{
      icon: 'icon-java-bold',
      title: 'Java'
   },{
      icon: 'icon-php',
      title: 'PHP'
   }
];

const frontend = [
   {
      icon: 'icon-javascript',
      title: 'Javascript'
   },{
      icon: 'icon-reactjs',
      title: 'React'
   },{
      icon: 'icon-html5',
      title: 'HTML5'
   },{
      icon: 'icon-css3',
      title: 'CSS3'
   },{
      icon: 'icon-jquery',
      title: 'jQuery'
   }
];

const dbs = [
   {
      icon: 'icon-mongodb',
      title: 'MongoDB'
   },{
      icon: 'icon-mysql',
      title: 'MySQL'
   },{
      icon: 'icon-postgres',
      title: 'PostgreSQL'
   }
];

class Skills extends Component {
   render() {
      return (
         <div className="main">
            <FadeIn duration="1.2s" timingFunction="ease-out">
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="about-title">Applications & Operating Systems</h3>
                  </div>
                  <div className="col-md-9">
                     {apps_operating_systems.map((data, index) => {
                        const { icon, title } = data;
                        return (
                           <div key={index} className="lang-container">
                              <i className={`${icon} lang-ico`}></i>
                              <h5 className="lang-title">{title}</h5>
                           </div>
                        )
                     })}
                  </div>
               </div>
               <hr />
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="backend-title">Back-end</h3>
                  </div>
                  <div className="col-md-9">
                     {backend.map((data, index) => {
                        const { icon, title } = data;
                        return (
                           <div key={index} className="backend lang-container">
                              <i className={`${icon} lang-ico`}></i>
                              <h5 className="lang-title">{title}</h5>
                           </div>
                        )
                     })}
                  </div>
               </div>
               <hr />
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="backend-title">Front-end</h3>
                  </div>
                  <div className="col-md-9">
                     {frontend.map((data, index) => {
                        const { icon, title } = data;
                        return (
                           <div key={index} className="backend lang-container">
                              <i className={`${icon} lang-ico`}></i>
                              <h5 className="lang-title">{title}</h5>
                           </div>
                        )
                     })}
                  </div>
               </div>
               <hr />
               <div className="row">
                  <div className="col-md-3">
                     <h3 className="backend-title">Databases</h3>
                  </div>
                  <div className="col-md-9">
                     {dbs.map((data, index) => {
                        const { icon, title } = data;
                        return (
                           <div key={index} className="backend lang-container">
                              <i className={`${icon} lang-ico`}></i>
                              <h5 className="lang-title">{title}</h5>
                           </div>
                        )
                     })}
                  </div>
               </div>
            </FadeIn>
         </div>
      );
   }
}

export default Skills;



// WEBPACK FOOTER //
// ./src/components/Skills.js